import NuabaseTokensApi from "@/packages/api/Nuabase/TokensApi";
import { jsonHeaders } from "@/packages/dashboard/csrf";
import { withAppDomain } from "@/packages/dashboard/utils/url-utils";

import { type NuabaseConfig, Nua } from "nuabase";
import { z } from "zod";

const tokenResponseSchema = z.object({
  access_token: z.string().min(1),
});

const fetchToken = async () => {
  const response = await fetch(withAppDomain(NuabaseTokensApi.create.path()), {
    method: "POST",
    headers: jsonHeaders(),
  });

  if (!response.ok) {
    const errorBody = await response.text();
    throw new Error(`Failed to fetch Nuabase token (${response.status}): ${errorBody}`);
  }

  const data = await response.json();
  const { access_token } = tokenResponseSchema.parse(data);
  return access_token;
};

const nuaConfig: NuabaseConfig = { fetchToken };

if (import.meta.env.DEV) {
  nuaConfig.baseUrl = "https://api.dbu6.dev";
}

export const nua = new Nua(nuaConfig);
